<template>
  <div class="logo-wrapper">
    <Logo />
    <div class="sidebar-pin-toggle" :class="{ pinned: sidebarPinned }"
      :title="sidebarPinned ? 'Bỏ ghim menu' : 'Ghim menu'" @click="togglePin">
      <span class="pin-dot"></span>
    </div>
  </div>
  <!-- <div class="dark-logo-wrapper">
    <router-link to="/"
      ><img class="img-fluid" src="../../assets/images/logo/dark-logo.png" alt=""
    /></router-link>
  </div> -->
  <!-- <div class="toggle-sidebar" @click="toggle_sidebar">
    <vue-feather
      class="status_toggle middle"
      type="align-center"
      id="sidebar-toggle"
    ></vue-feather>
  </div> -->
</template>
<script>
import { mapState } from "vuex";
import Logo from "../slidebar/logoView.vue";
export default {
  components: {
    Logo,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
      sidebarPinned: (state) => state.menu.sidebarPinned,
    }),
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch("menu/opensidebar");
      this.$store.state.menu.activeoverlay = false;
    },
    togglePin() {
      this.$store.dispatch("menu/toggleSidebarPin");
    },
  },
};
</script>
<style scoped>
.logo-wrapper {
  padding: 22px 0 0 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-pin-toggle {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  border-radius: 50%;
  border: 2px solid var(--theme-deafult);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.sidebar-pin-toggle .pin-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--theme-deafult);
  transform: scale(0);
  transition: transform 0.2s ease;
}

.sidebar-pin-toggle.pinned .pin-dot {
  transform: scale(1);
}

/* Mobile vẫn dùng nút mở/đóng cũ */
@media (max-width: 1199px) {
  .sidebar-pin-toggle {
    display: none;
  }
}
</style>